import React from 'react';
import Box from '@mui/material/Box';
import { OpenAPIV3_1 as OpenAPI } from "openapi-types";
import _ from 'lodash';
import SplitPane from '../SplitPane';
import ResponseBox from '../ResponseBox';
import RequestBox from '../RequestBox';
import { httpPatch } from 'src/api';

export interface PatchProps {
    operationObject: OpenAPI.OperationObject;
}

const Patch: React.FC<PatchProps> = ({ operationObject }) => {
    const { responses } = operationObject;

    return (
        <Box>
            <SplitPane
                req={
                    <RequestBox
                        operationObject={operationObject}
                        runRequest={
                            (pathKey, pathParams, queryParams, body) => httpPatch(pathKey, pathParams, queryParams, body)
                        }
                    />
                }
                res={<ResponseBox responsesObject={responses} />}
            />
        </Box>
    );
};

export default Patch;
